export default [
    {
        key: "forwardhead",
        name: "Наклон головы вперед",
        definition: {
            name: "Определение",
            list: ["Наклон головы вперед означает, что когда человеческое тело находится в естественной позе стоя или сидя, голова находится в аномально наклоненном вперед положении относительно туловища. Часто встречается у долго сидящих студентов и офисных работников."]
        },
        triggerreason: {
            name: "Причины",
            list: [
                "1、Длительное наклонное положение при работе. Когда долго работают перед компьютером, голова обычно вытягивается вперед.",
                "2. Привычка опускать голову, чтобы посмотреть на телефон. Смотреть на телефон с опущенной головой, т.е. так называемая ‘племя головопоклонников’, также является основной причиной наклона головы вперед.",
            ]
        },
        danger: {
            name: "Последствия",
            list: [
                "1. Головокружение и головная боль: Наклон головы вперед может повлиять на кровообращение в голове. Из-за плохого кровотока возникает дефицит кислорода в голове, что вызывает головокружение и головную боль.",
                "2. Болезни шейного отдела позвоночника: Из-за неправильного положения головы возникают аномалии в мягких тканях и костях шеи, увеличивая риск развития заболеваний шейного отдела позвоночника.",
                "3. Сердечно-сосудистые и цереброваскулярные заболевания: Неправильное положение головы может повлиять на кровообращение в голове и навредить здоровью сердечно-сосудистой и цереброваскулярной системы.",
            ],
        }
    },
    {
        key: "lateralhead",
        name: "Боковое наклонение головы",
        definition: {
            name: "Определение",
            list: ["Боковое наклонение головы означает ненормальное положение, когда голова чрезмерно наклоняется в сторону при естественной позе стояния или сидения человека. Основная причина - дисбаланс силы мышц шеи и плеч с обеих сторон, обычно вызванный привычными неправильными позами."]
        },
        triggerreason: {
            name: "Причины",
            list: [
                "1. Привычка использовать мышцы шеи и плеча с одной стороны: Когда сидишь или лежишь, шея часто наклоняется только в одну сторону, что вызывает дисбаланс силы мышц шеи и плеч с обеих сторон.",
            ]
        },
        danger: {
            name: "Последствия",
            list: [
                "1. Хроническая усталость мышц и связок: Долгое боковое наклонение головы может легко привести к хроническому переутомлению задних связок шеи и связок и мышц.",
                "2. Болезни шейного отдела позвоночника: Из-за неправильного положения головы возникают аномалии в мягких тканях и костях шеи, увеличивая риск развития заболеваний шейного отдела позвоночника.",
            ],
        }
    },
    {
        key: "unevenshoulder",
        name: "неровные плечи",
        definition: {
            name: "Определение",
            list: ["неровные плечи означает ситуацию, когда плечи с двух сторон имеют разную высоту в вертикальном направлении, когда человеческое тело находится в естественном состоянии расслабления. Обычно неравные плечи сопровождаются аномалиями в положении позвоночника."]
        },
        triggerreason: {
            name: "Причины",
            list: [
                "1. Чрезмерная нагрузка на одну сторону: например, долго носить рюкзак или тяжелые предметы на одной стороне.",
                "2. Долгое время неправильная поза: Возникает из-за плохих привычек, таких как скрещивание ног и долгое сидение, или наклон над столом при работе сидя.",
            ]
        },
        danger: {
            name: "Последствия",
            list: [
                "1. Боль в пояснице: (неровные плечи) могут вызвать смещение таза, что приведет к дисбалансу силы мышц с двух сторон талии и вызовет боль в пояснице.",
                "2. Остеофит: Неровные плечи вызывают аномальную нагрузку на шейный отдел позвоночника и в конечном итоге могут привести к дегенерации области шейного отдела позвоночника и легко образовать остеофиты.",
            ],
        }
    },
    {
        key: "roundedshoulder",
        name: "округлые плечи",
        definition: {
            name: "Определение",
            list: ["Круглые плечи — это состояние, когда плечи с боковой стороны кажутся согнутыми вперед и внутрь. Часто сопровождается сутулостью. Часто встречается у студентов и людей, работающих в офисах."],
        },
        triggerreason: {
            name: "Причины",
            list: [
                "1. Плохая привычная поза: например, сутулость и горб, неправильное положение на боку и т. д.",
                "2. Disequilibrio muscular en el pecho y la espalda: Los músculos pectorales son relativamente débiles en comparación con los músculos de la espalda.",
            ]
        },
        danger: {
            name: "Последствия",
            list: [
                "1. Увеличение нагрузки на сердце: Чрезмерно округлые плечи приведут к напряжению диафрагмы, что вызовет сдавление аорты и полой вены и увеличит нагрузку на сердце.",
                "2. Сдавление нервов: Напряжение мышц вокруг плеч и шеи может в тяжелых случаях привести к сдавлению нервов шейного отдела позвоночника, вызвать головную боль и онемение руки.",
            ],
        }
    },
    {
        name: "сколиоз позвоночника",
        key: "scoliosis",
        definition: {
            name: "Определение",
            list: ["Происходят аномалии в положении позвоночника. С помощью визуализационных исследований может быть обнаружено искривление позвоночника и другие не прямые состояния позвоночника. Аномалии могут быть разделены на врожденные и приобретенные. Приобретенные аномалии связаны с неправильными привычками осанки."],
        },
        triggerreason: {
            name: "Причины",
            list: [
                "1. Чрезмерная односторонняя нагрузка: например, долгое время носить рюкзак или поднимать тяжелые предметы с одной стороны.",
                "2. Долгое время неправильная поза: Возникает из-за плохих привычек, таких как скрещивание ног и долгое сидение, или наклон над столом при работе сидя.",
                "3. Причины врожденные: Сколиоз позвоночника, вызванный врожденными факторами.",
            ]
        },
        danger: {
            name: "Последствия",
            list: [
                "1. Протрузия межпозвоночного диска в поясничном отделе.",
                "2. Боль в пояснице: Может вызвать смещение таза, что приведет к дисбалансу мышечной силы с двух сторон талии и вызовет боль в пояснице.",
                "3. Разной длины ноги.",
            ],
        }
    },
    {
        name: "боковое наклонение таза",
        key: "unevenhip",
        definition: {
            name: "Определение",
            list: ["Боковое наклонение таза относится к состоянию, когда высота таза с двух сторон значительно отличается, проявляясь в виде наклона таза. Часто сопровождается аномалиями положения позвоночника и разной высоты плеч."],
        },
        triggerreason: {
            name: "Причины",
            list: [
                "1. Долгое время неправильная поза: Возникает из-за плохих привычек, таких как скрещивание ног и долгое сидение, или наклон над столом при работе сидя.",
                "2. Прирожденная разная длина ног: Боковое наклонение таза, вызванное прирожденной разной длиной ног.",
                "3. Несбалансированность осанки нижних конечностей с двух сторон: например, одна нога имеет плоскостопие, а другая нет, или степень отличается; на обеих ногах есть гиперэкстензия колена, но степень различна.",
            ]
        },
        danger: {
            name: "Последствия",
            list: [
                "1. Протрузия межпозвоночного диска в поясничном отделе.",
                "2. Хроническая боль: Боковое наклонение таза может вызвать боль в ногах, пояснице, а также в шее и плечах.",
                "3. Разной длины ноги.",
            ],
        }
    },
    {
        name: "колени в форме буквы О",
        key: "oleg",
        definition: {
            name: "Определение",
            list: ["Когда человек стоит в нормальной позе и ноги вместе, внутренние лодыжки могут прижиматься друг к другу, но внутренние колени не могут прижиматься и может даже быть большая щель. Между ногами появляется форма \"О\". Этот тип формы ног связан с ежедневными привычками осанки. Появление О-образных ног у детей также может быть связано с рахитом."],
        },
        triggerreason: {
            name: "Причины",
            list: [
                "1. Плохие привычки осанки, такие как: отклонение таза назад и склонность к пронации стопы.",
                "2. Несбалансированность мышечной силы, например: слишком напряженные внешние мышцы ротаторы бедра.",
            ]
        },
        danger: {
            name: "Последствия",
            list: [
                "1. Повреждение медиального мениска: Ноги в форме буквы O вызывают изменения в силовой линии нижних конечностей. Медиальный зазор коленного сустава подвергается давлению, превышающему нормальную нагрузку. Это может вызвать повреждение медиального мениска коленного сустава.",
                "2. Артрит: Тяжелые случаи (ноги в форме буквы О) могут в конечном итоге привести к остеоартриту коленного сустава и дегенерации сустава в боковом суставном промежутке. В тяжелых случаях может потребоваться операция по замене искусственного сустава.",
            ],
        }
    },
    {
        name: "ноги в форме буквы X",
        key: "xleg",
        definition: {
            name: "Определение",
            list: "Когда человек стоит в нормальной позе, и ноги вместе, внутренние колени могут быть прижаты друг к другу, но внутренняя сторона лодыжек не может быть прижата и может даже быть большая щель. Форма между ногами похожа на букву \"X\". Этот тип формы ног связан с ежедневными привычками осанки и дисбалансом мышечной силы.",
        },
        triggerreason: {
            name: "Причины",
            list: [
                "1. Привычные неправильные позы, такие как: наклон таза вперед, тенденция к вывороту стопы.",
                "2. Несбалансированность мышечной силы, например: слишком напряженные мышцы внутренней ротации бедра.",
            ]
        },
        danger: {
            name: "Последствия",
            list: [
                "1. Повреждение латерального мениска: Ноги в форме буквы X вызывают изменения в силовой линии нижних конечностей. Латеральный зазор коленного сустава подвергается давлению, превышающему нормальную нагрузку. Это может вызвать повреждение латерального мениска коленного сустава.",
                "2. Артрит: Тяжелые случаи (ноги в форме буквы X) могут в конечном итоге привести к остеоартриту коленного сустава и дегенерации сустава в боковом суставном промежутке. В тяжелых случаях может потребоваться операция по замене искусственного сустава.",
            ],
        }
    },
    {
        name: "гиперэкстензия колена",
        key: "kneehyperextension",
        definition: {
            name: "Определение",
            list: ["Гиперэкстензия колена, также известная как ?обратный изгиб колена?. Сбоку человеческого тела видно, что нога изгибается назад, колено вогнуто внутрь, и голень чрезмерно выдвинута вперед по сравнению с бедром. Этот тип осанки часто встречается у балерин и людей со слабой мышечной силой бедра."],
        },
        triggerreason: {
            name: "Причины",
            list: [
                "1. Неправильная поза приложения силы: при стоянии основной вес приходится на переднюю часть ступни.",
                "2. Напряжение подошвенной фасции: Может быть вызвано длительным ношением высоких каблуков.",
                "3. Слабость мышц вокруг колена. Недостаточная сила мышц передней и задней части бедра.",
            ]
        },
        danger: {
            name: "Последствия",
            list: [
                "1. Деформация коленного сустава: Долгосрочная гиперэкстензия колена может привести к значительному увеличению частоты дегенерации суставов и вызвать чрезмерный износ коленного сустава, что приведет к деформации сустава.",
                "2. Повреждение общего баланса: Между тремя суставами - бедром, коленом и лодыжкой - существует большая позиционная и функциональная связь. Изменение положения колена повлияет на положение лодыжки ниже и положение бедра и таза выше, постепенно нанося ущерб общему балансу тела. В долгосрочной перспективе это может вызвать различные виды боли.",
            ],
        }
    },
]